import { createInstance, type i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';

import localesEn from './i18n-locales-en';
import localesRu from './i18n-locales-ru';

export type UniCreditLanguage = 'en' | 'ru';

const i18nextResources = {
  en: { translation: localesEn },
  ru: { translation: localesRu },
};

const i18next = 
  createInstance({
    resources: i18nextResources,
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false,
    },
    debug: process.env.NODE_ENV === 'development',
  });

i18next
  .use(initReactI18next)
  .init();

export function syncWebUiKitLanguageWith(i18nOtherLib: i18n) {
  const syncLanguageWith = (i18nInstance: i18n) => (lng: string) => {
    if (i18nInstance.language !== lng) {
      i18nInstance.changeLanguage(lng);
    }
  };

  if (i18nOtherLib.language !== i18next.language) {
    i18next.changeLanguage(i18nOtherLib.language);
  }

  i18next.on('languageChanged', syncLanguageWith(i18nOtherLib));
  i18nOtherLib.on('languageChanged', syncLanguageWith(i18next));
}

export default i18next;
